import { z } from 'zod';

/**
 * `business.users.profileId` do legado, o perfil de CASA do usuário (o `UserProfile` do
 * `voll_modules_library`, `user_profile.dart`). O número é o nível: quanto menor, mais poder,
 * exceto o REQUESTER, um perfil à parte (a secretária que pede viagem para os executivos).
 */
export const UserProfileId = {
  OWNER: 0,
  MASTER: 1,
  ADMIN: 2,
  MANAGER: 3,
  BASIC: 4,
  PASSENGER: 5,
  REQUESTER: 6,
} as const;
export type UserProfileId = (typeof UserProfileId)[keyof typeof UserProfileId];

/** Quem vê a tela Solicitações: o solicitante e os perfis de administração (OWNER, MASTER,
 *  ADMIN). MANAGER, BASIC e PASSENGER ficam fora, mesmo tendo pedido para outras pessoas. */
const REQUESTED_SCREEN_PROFILE_IDS: ReadonlySet<number> = new Set([
  UserProfileId.OWNER,
  UserProfileId.MASTER,
  UserProfileId.ADMIN,
  UserProfileId.REQUESTER,
]);

/** Se o perfil vê Solicitações; `null`/`undefined` = desconhecido, nega. */
export function isRequestedScreenProfile(profileId: number | null | undefined): boolean {
  return profileId != null && REQUESTED_SCREEN_PROFILE_IDS.has(profileId);
}

/** `/me.requested`: o veredito da tela Solicitações, costurado só pelo BFF. Ao contrário
 *  das outras entradas, sai também `allowed: false`: a chave AUSENTE (BFF antigo, lookup fora) deixa o menu como sempre, e quem barra é o 403. */
export const RequestedEntrySchema = z.object({ allowed: z.boolean() }).strict();
export type RequestedEntry = z.infer<typeof RequestedEntrySchema>;
